export default {"src":"/_next/static/media/swimming_pool_64.1164401e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};